export default "__VITE_ASSET__CF$U1dUy__"